import { render, staticRenderFns } from "./InternationalMobile.vue?vue&type=template&id=1a28cd44&"
import script from "./InternationalMobile.vue?vue&type=script&lang=js&"
export * from "./InternationalMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports